// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BP-La","avatar":"styles_avatar__2pdyT","myQuestion":"styles_myQuestion__1UkRH"};